/* eslint-disable quotes */
import React, { useEffect, useState } from 'react';
import './styles.css';
import { Checkbox, FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import GradientButton from '../customMui/newButton/newButton';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRoomContext } from '../../RoomContext';
import { getSurveyQuestions, submitSurvey } from '../../libs/apis/webinarApi';
import Loading from '../Loader/Loading';
import DotSpin from '../Loader/dotSpin';
import { useIntl } from 'react-intl';

function Feedback(props)
{

	const {
		surveyDataStore
		// setSurveyDataStore,
		// roomClient,
		// myId,
		// me
	} = props;

	const intl = useIntl();

	// const [ value, setValue ] = useState(0);
	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;

	const meetingId = parameters.get('id');
	const sessionId = parameters.get('sessionId');
	const wMail = window.atob(parameters.get('uid'));
	const wName = parameters.get('name');
	const [ loader, setLoader ] = useState(false);

	const [ surveyData, setSurveyData ] = useState({});

	const [ state, setState ] = useState(false);
	const [ load, setLoad ] = useState(false);

	const [ answers, setAnswers ] = useState({});

	const getSurveyData = () =>
	{
		setLoader(true);
		getSurveyQuestions(meetingId)
			.then((res) =>
			{
				console.log('res', res);

				if (res?.status)
				{
					const resData = res?.data;

					if (resData)
					{
						setSurveyData(resData);
					}

					setLoader(false);
				}

			})
			.catch((e) =>
			{
				console.log('err', e);
				setLoader(false);
			});
	};

	const handleAnswerChange = (questionId, answer) =>
	{
		setAnswers((prevAnswers) => ({
			...prevAnswers,
			[questionId] : answer
		}));
	};
	const handleSubmit = async () =>
	{
		setLoad(true);
		const surveyPayload = {
			surveyId  : surveyData._id,
			meetingId : meetingId,
			userName  : wName,
			userEmail : wMail,
			answers   : Object.entries(answers).map(([ questionId, answer ]) => ({ questionId, answer }))
		};

		try
		{

			const res=await submitSurvey(surveyPayload);

			console.log(res);

			setState(true);
			setLoad(false);
			const timeoutId = setTimeout(() =>
			{
				const url = `https://${window.location.host}/register?id=${meetingId}&sessionId=${sessionId}`;

				window.location.href = url;
			}, 3000);

			return () => clearTimeout(timeoutId);

		}
		catch (err)
		{
			console.log('errr', err);
			setState(false);

		}

	};

	const handleSkip = () =>
	{
		const url = `https://${window.location.host}/register?id=${meetingId}&sessionId=${sessionId}`;

		window.location.href = url;
	};

	useEffect(() =>
	{
		getSurveyData();
	}, []);

	console.log('surveyDataStore___', surveyDataStore);

	return (
		<div className='flexCol aCntr feedbackPg '>
			<div className='flexRow jBtwn pdngMD feedBackBdr'>
				<img src='/images/inmeet1.png' alt='logo' className='logo ' />
				<GradientButton variant='contained' color='primary' disableElevation size='small' onClick={handleSkip} >{intl.formatMessage({ id: 'Skip_Survey', defaultMessage: 'Skip Survey' })}</GradientButton>
			</div>
			{ loader ?
				<Loading/>
				:
				<div className='flexCol aCntr pdngXL gap16 feedbackWidth feedBackHg'>
					<div className='flexCol whiteBg pdngMD gap16 brdrRadiusSM'>
						<span className='mHdng'>{surveyData?.title}</span>
						{ surveyData?.description &&
						<p>{surveyData?.description}</p>
						}
					</div>
					{ surveyData?.questions?.map((each, index) => (
						<div className='flexCol' key={index}>
							{console.log('eacheacheach', each)}
							{ each?.questionType === 'short' &&
							<div className='flexCol whiteBg pdngMD brdrRadiusSM '>
								<span className='mHdng'>{each?.question}</span>
								<TextField
									size='small'
									type='text'
									variant='standard'
									placeholder={intl.formatMessage({ id: 'Type_your_answer', defaultMessage: 'Type your answer here' })}
									margin='normal'
									fullWidth
									onChange={(e) => handleAnswerChange(each.questionId, e.target.value)}
								/>
							</div> }
							{ each?.questionType === 'singleChoice' &&
							<div className='flexCol whiteBg pdngSM brdrRadiusSM '>
								<span className='mHdng'>{each?.question}</span>
								<RadioGroup
									value={answers[each.questionId] || ''}
									onChange={(e) => handleAnswerChange(each.questionId, e.target.value)}
								>
									{each?.options?.split(',')?.map((opt, i) => (
										opt.trim() !== '' && (
											<FormControlLabel
												key={i}
												value={opt.trim()}
												control={<Radio color='primary' size='small' />}
												label={opt.trim()}
											/>
										)
									))}
								</RadioGroup>
							</div> }
							{ each?.questionType === 'multipleChoice' &&
							<div className='flexCol whiteBg pdngSM brdrRadiusSM '>
								<span className='mHdng'>{each?.question}</span>
								{each?.options?.split(',')?.map((opt, i) => (
									opt.trim() !== '' && (
										<FormControlLabel
											key={i}
											control={
												<Checkbox
													color='primary'
													checked={answers[each.questionId]?.includes(opt.trim()) || false}
													onChange={(e) =>
													{
														const selectedOptions = answers[each.questionId] || [];

														if (e.target.checked)
														{
															selectedOptions.push(opt.trim());
														}
														else
														{
															const indexx = selectedOptions.indexOf(opt.trim());

															if (indexx !== -1)
															{
																selectedOptions.splice(indexx, 1);
															}
														}
														handleAnswerChange(each.questionId, selectedOptions);
													}}
												/>
											}
											label={opt.trim()}
										/>
									)
								))}
							</div> }
							{ each?.questionType === 'star' &&
							<div className='flexCol whiteBg pdngMD gap16 brdrRadiusSM'>
								<span className='mHdng'>{each?.question}</span>
								<div className='flexRow'>
									<Rating
										className='rating'
										// eslint-disable-next-line prefer-template
										name={'rating-' + each.questionId} // Unique name for each Rating component
										value={answers[each.questionId] || 0}
										style={{ fontSize: '3rem' }}
										onChange={(event, newValue) => handleAnswerChange(each.questionId, newValue, index)}
									/>
								</div>
							</div> }
						</div>
					))}
					<div className='flexRow aCntr jEnd pdngVSM gap16  '>
						{/* { load && <CircularProgress variant='indeterminate' disableShrink size='2rem'/> } */}
						{/* { load && <DotSpinLoader variant='indeterminate' disableShrink size='2rem'/> } */}
						{ load && <DotSpin variant='indeterminate' disableShrink size='2rem'/> }
						<GradientButton
							variant='contained'
							color='primary'
							disableElevation
							disabled={Object.keys(answers).length === 0}
							style={{ borderRadius: '10px' }}
							className='pointer'
							onClick={handleSubmit}
						>
							{intl.formatMessage({ id: 'submit', defaultMessage: 'SUBMIT' })}
						</GradientButton>

					</div>
				</div>
			}
			{state === true &&
			<div className='flexCol aCntr feedbackPg1'>
				<div className='flexCol submitFeebackHg jCntr aCntr gap16'>
					<img src='/images/feedback.svg ' alt='feedback' className='feedbackImg'/>
					<span className='mHdng'>{intl.formatMessage({ id: 'Thank_for_submitting_your_feedback', defaultMessage: 'Thank you for submitting your feedback' })}</span>
					<span >{intl.formatMessage({ id: 'Your_feedback_has_been_sent', defaultMessage: 'Your feedback has been sent !' })}</span>
				</div>

			</div>
			}
		</div>

	);
}

Feedback.propTypes =
{
	// roomClient      : PropTypes.object,
	surveyDataStore : PropTypes.any,
	setSurveyData   : PropTypes.any
	// setSurveyDataStore : PropTypes.func,
	// myId            : PropTypes.string,
	// me              : PropTypes.any

};

const mapStateToProps = (state) => ({
	surveyDataStore : state.webinar.surveyDataStore
	// myId            : state.me.id,
	// me              : state.me

});

const mapDispatchToProps = () => ({

	// setSurveyDataStore : (survey) => dispatch(webinarActions.setSurveyDataStore(survey))
});

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.webinar.surveyDataStore === next.webinar.surveyDataStore
				// prev.me.id === next.me.id
			);
		}
	}
)(Feedback));